/*
 * @Author: kennthKun c_kunx@163.com
 * @Date: 2022-11-03 15:34:48
 * @LastEditors: kennthKun c_kunx@163.com
 * @LastEditTime: 2022-11-03 16:33:31
 * @FilePath: /kx_component/src/components/UploadImg/ocr.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from './request'
const API_ENV = process.env.API_ENV;

interface OCRData {
  code: string,
  facePhotoUrl?: string,
  backPhotoUrl?: string
}

const OCR = async (data: OCRData) => {
  const res = await request(`https://${API_ENV}.${API_ENV === 'lyt' ? "lieyuntong.cn" : "ailieyun.com"}/api/custom/basisOcr/identify`, {
    method: 'POST',
    data: { data },
  })
  return res
}

export default OCR